<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" style="margin-bottom: 180px">
      <div class="col-md-12">
        <b-card>
          <div v-show="show"
            class="alert alert-danger alert-dismissible fade show"
            role="alert"
          >
            <span v-for="(err, index) in validation_errors" :key="index">
              {{ err[0] }} <br />
            </span>
          </div>

          <form action="">
            <div class="form-row">
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="c_ep_type">EP Type <span class="c-required">*</span></label>
                <select
                  v-model="ses.c_ep_type_id"
                  v-validate="'required'"
                  id="c_ep_type"
                  name="c_ep_type"
                  class="form-control form-control-sm">
                  <option selected disabled :value="''">Select EP type</option>
                  <option v-for="(ep, index) in ep_types" :value="ep.id"
                    :key="index">{{ ep.desc }}</option>
                </select>
                <div class="invalid-feedback">
                  Please select an ep type.
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="form_no">Form No. <span class="c-required">*</span></label>
                <input
                  type="number"
                  v-model="ses.form_no"
                  v-validate="'required|length:8'"
                  id="form_no"
                  name="form_no"
                  class="form-control form-control-sm"
                  placeholder="Form number"
                />
                <div class="invalid-feedback">
                  Please enter form number.
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="mobile">Mobile No. <span class="c-required">*</span></label>
                <input
                  type="number"
                  v-model="ses.mobile"
                  v-validate="'required|length:11'"
                  id="mobile"
                  name="mobile"
                  class="form-control form-control-sm"
                  placeholder="Mobile number"
                />
                <div class="invalid-feedback">
                  Please enter mobile number.
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="nid" class="col-form-label col-form-label-sm">
                  <span v-if="ses.id_type === 'N'">National ID <span class="c-required">*</span></span>
                  <span v-if="ses.id_type === 'P'">Passport No. <span class="c-required">*</span></span>
                  <span v-if="ses.id_type === 'B'">Birth Certificate No. <span class="c-required">*</span></span>
                </label>
                <div class="row m-0">
                  <div class="col-3 p-0">
                    <select
                      class="form-control form-control-sm"
                      v-model="ses.id_type"
                    >
                      <option value="N">NID</option>
                      <option value="P">Passport</option>
                      <option value="B">Birth</option>
                    </select>
                  </div>
                  <div class="col-9 p-0">
                    <input type="text" v-model="ses.nid"
                      v-validate="{required: true,regex: /^[a-zA-Z0-9_.-]*$/,min: 6}" id="nid" name="nid"
                      class="form-control form-control-sm"
                      placeholder="Enter number"/>
                  </div>
                  <div class="invalid-feedback">
                    Please enter a valid number.
                  </div>
                </div>
              </div>
            </div>

            <div class="form-row mt-2">
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="household_number">Household No. <span class="c-required">*</span></label>
                <input type="number"
                  v-model="ses.household_number" v-validate="'min:1'"  id="household_number"  name="household_number"
                  class=" form-control form-control-sm" placeholder="Household number"/>
                <div class="invalid-feedback">
                  Please enter household number.
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="name">Name of Household Head <span class="c-required">*</span></label>
                <input type="text" v-model="ses.name"
                  v-validate="{ required: true, regex: /^[a-zA-Z\.\s]*$/ }" id="name" name="name"
                       class=" form-control form-control-sm"
                  placeholder="Household head name"/>
                <div class="invalid-feedback">
                  Please enter household head name.
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="father_husband_name">
                  <span v-if="ses.father_hus_type === 'F'">Father Name <span class="c-required">*</span></span>
                  <span v-if="ses.father_hus_type === 'H'">Husband Name <span class="c-required">*</span></span>
                  <span v-if="ses.father_hus_type === 'S'">Spouse Name. <span class="c-required">*</span></span>
                </label>
                <div class="row m-0">
                  <div class="col-3 p-0">
                    <select
                      v-model="ses.father_hus_type"
                      v-validate="{ required: true }"
                      name="father_or_husband"
                      class="form-control form-control-sm"
                    >
                      <option value="F">Father</option>
                      <option value="H">Husband</option>
                      <option value="S">Spouse</option>
                    </select>
                  </div>
                  <div class="col-9 p-0">
                    <input type="text" v-model="ses.father_husband_name"
                      v-validate="{ required: true, regex: /^[a-zA-Z\.\s]*$/ }"  id="father_husband_name"
                      name="father_husband_name"
                      class=" form-control form-control-sm"
                      placeholder="Father/Husband name"
                    />
                    <div class="invalid-feedback">
                      Please enter Father/Husband name.
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="mother_name">Mother Name <span class="c-required">*</span></label>
                <input type="text" v-model="ses.mother_name"
                  v-validate="{ required: true, regex: /^[a-zA-Z\.\s]*$/ }" id="mother_name" name="mother_name"
                  class=" form-control form-control-sm"
                  placeholder="Mother's name"/>
                <div class="invalid-feedback">
                  Please enter Mother's name.
                </div>
              </div>
            </div>

            <div class="form-row mt-2">
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="dob">Date of Birth <span class="c-required">*</span></label>
                <datepicker :format="customDateDob" v-model="ses.dob" id="dob"></datepicker>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="c_gender_id">Gender <span class="c-required">*</span></label>
                <select
                  v-model="ses.c_gender_id"
                  v-validate="'required'"
                  id="c_gender_id"
                  name="c_gender_id"
                  class="form-control form-control-sm"
                >
                  <option selected disabled :value="''">Select Gender</option>
                  <option
                    v-for="(gender, index) in genders"
                    :key="index"
                    :value="gender.id"
                    >{{ gender.desc }}</option
                  >
                </select>
                <div class="invalid-feedback">
                  Please select a gender.
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="religion">Religion <span class="c-required">*</span></label>
                <select
                  v-model="ses.c_religion_id"
                  v-validate="'required'"
                  id="religion"
                  name="religion"
                  class="form-control form-control-sm"
                >
                  <option selected disabled :value="''"
                    >Select a Religion</option
                  >
                  <option
                    v-for="(religion, index) in religions"
                    :key="index"
                    :value="religion.id"
                    >{{ religion.desc }}</option
                  >
                </select>
                <div class="invalid-feedback">
                  Please select a religion.
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="education">Education <span class="c-required">*</span></label>
                <select
                  v-model="ses.c_education_id"
                  v-validate="'required'"
                  id="education" name="education"
                  class="form-control form-control-sm"
                >
                  <option selected disabled :value="''"
                    >Select a Education type</option
                  >
                  <option
                    v-for="(education, index) in educations"
                    :key="index"
                    :value="education.id"
                    >{{ education.desc }}</option
                  >
                </select>
                <div class="invalid-feedback">
                  Please select a Education.
                </div>
              </div>
            </div>

            <div class="form-row mt-2">
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="marital_status">Marital Status <span class="c-required">*</span></label>
                <select
                  v-model="ses.c_marital_status_id"
                  v-validate="'required'"
                  id="marital_status"
                  name="marital_status"
                  class="form-control form-control-sm"
                >
                  <option selected disabled :value="''">Select a status</option>
                  <option
                    v-for="(marital_status, index) in marital_statuses"
                    :key="index"
                    :value="marital_status.id"
                    >{{ marital_status.desc }}</option
                  >
                </select>
                <div class="invalid-feedback">
                  Please select maritial status.
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="occupation">Main Occupation <span class="c-required">*</span></label>
                <select
                  v-model="ses.c_occupation_id"
                  v-validate="'required'"
                  id="occupation"
                  name="occupation"
                  class="form-control form-control-sm"
                >
                  <option selected disabled :value="''"
                    >Select an occupation</option
                  >
                  <option
                    v-for="(occupation, index) in occupations"
                    :key="index"
                    :value="occupation.id"
                    >{{ occupation.desc }}</option
                  >
                </select>
                <div class="invalid-feedback">
                  Please select occupation.
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="village">Village <span class="c-required">*</span></label>
                <select
                  v-model="ses.c_village_id"
                  v-validate="'required'"
                  id="village" name="village"
                  class="form-control form-control-sm"
                  @change="getAddress(ses.c_village_id)"
                >
                  <option selected disabled :value="''"
                    >Select a village</option
                  >
                  <option
                    v-for="(village, index) in villages"
                    :key="index"
                    :value="village.id"
                    >{{ village.id }} : {{ village.desc }}</option
                  >
                </select>
                <div class="invalid-feedback">
                  Please select Village.
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="mouza">Mouza <span class="c-required">*</span></label>
                <select
                  v-model="ses.c_mouza_id"
                  v-validate="'required'"
                  id="mouza" name="mouza"
                  disabled
                  class="custom-select custom-select-sm"
                >
                  <option selected disabled :value="''">Select a mouza</option>
                  <option
                    v-for="(mouza, index) in mouzas"
                    :key="index"
                    :value="mouza.id"
                    >{{ mouza.id }} : {{ mouza.desc }}</option
                  >
                </select>
                <div class="invalid-feedback">
                  Please select Mouza.
                </div>
              </div>
            </div>
            <div class="form-row mt-2">
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="union">Union <span class="c-required">*</span></label>
                <select
                  v-model="ses.c_union_id"
                  v-validate="'required'"
                  id="union" name="union"
                  class="custom-select custom-select-sm"
                  disabled
                >
                  <option selected disabled :value="''">Select a union</option>
                  <option
                    v-for="(union, index) in unions"
                    :key="index"
                    :value="union.id"
                    >{{ union.id }} : {{ union.desc }}</option
                  >
                </select>
                <div class="invalid-feedback">
                  Please select Union.
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="upazila">Upazila <span class="c-required">*</span></label>
                <select
                  v-model="ses.c_upazila_id"
                  v-validate="'required'"
                  id="upazila" name="upazila"
                  class="custom-select custom-select-sm"
                  disabled
                >
                  <option selected disabled :value="''"
                    >Select a upazila</option
                  >
                  <option
                    v-for="(upazilla, index) in upazillas"
                    :key="index"
                    :value="upazilla.id"
                    >{{ upazilla.id }} : {{ upazilla.desc }}</option
                  >
                </select>
                <div class="invalid-feedback">
                  Please select upazilla.
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="district">District <span class="c-required">*</span></label>
                <select
                  v-model="ses.c_district_id"
                  v-validate="'required'"
                  id="district" name="district"
                  class="custom-select custom-select-sm"
                  disabled
                >
                  <option selected disabled :value="''"
                    >Select a district</option
                  >
                  <option
                    v-for="(district, index) in districts"
                    :key="index"
                    :value="district.id"
                    >{{ district.desc }}</option
                  >
                </select>
                <div class="invalid-feedback">
                  Please select district.
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="division">Division <span class="c-required">*</span></label>
                <select
                        v-model="ses.c_division_id"
                        v-validate="'required'"
                  id="division" name="division"
                  class="custom-select custom-select-sm"
                  disabled
                >
                  <option selected disabled :value="''"
                    >Select a division</option
                  >
                  <option
                    v-for="(division, index) in divisions"
                    :key="index"
                    :value="division.id"
                    >{{ division.desc }}</option
                  >
                </select>
                <div class="invalid-feedback">
                  Please select division.
                </div>
              </div>
            </div>

            <div class="form-row mt-2">
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="yearly_income">1.16 Family/Institution Yearly Income</label>
                <input type="number"
                  v-model="ses.yearly_income" v-validate="'numeric'"
                  id="yearly_income" name="yearly_income"
                  class="form-control form-control-sm"
                  placeholder="Family/Institution Yearly Income"
                />
                <div class="invalid-feedback">
                  Please enter yearly income.
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="yearly_exp">1.17 Family/Institution Yearly Expenditure</label>
                <input type="number"
                  v-model="ses.yearly_exp" v-validate="'numeric'"
                  id="yearly_exp" name="yearly_exp"
                  class="form-control form-control-sm"
                  placeholder="Family/Institution Yearly Expenditure"/>
                <div class="invalid-feedback">
                  Please enter yearly income.
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="indigenous">1.18 If Indigenous <span class="c-required">*</span></label>
                <input
                  v-model="ses.indigenous"
                  v-validate="'required'"
                  id="indigenous" name="indigenous"
                  placeholder="Present address"
                  class="form-control form-control-sm"
                />
                <div class="invalid-feedback">
                  Please enter Indigenous people info
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="institution_sec"
                  >1.9 Name of Institution Secretary <span class="c-required">*</span></label
                >
                <input
                        v-model="ses.inistitution_sec"
                        v-validate="'required'"
                  id="institution_sec"
                  name="institution_sec"
                  placeholder=" Name of Institution Secretary"
                  class="form-control form-control-sm"
                />
              </div>
            </div>

            <div class="form-row mt-2">
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="type_cpr">1.20 Type Of CPR <span class="c-required">*</span></label>
                <select v-model="ses.c_cpr_id" v-validate="'required'" id="type_cpr" name="type_cpr"
                        class="form-control form-control-sm">
                  <option selected disabled :value="''">Select Type Of CPR</option>
                  <option
                    v-for="(cpr, index) in cprs"
                    :key="index"
                    :value="cpr.id">{{ cpr.desc }}</option>
                </select>
                <div class="invalid-feedback">
                  Please select CPR.
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="utilities">07. Affected Utilities</label>
                <multiselect
                  v-model="ses.utilities"
                  :multiple="true"
                  :clear-on-select="false"
                  :preserve-search="true"
                  label="desc"
                  track-by="id"
                  :preselect-first="true"
                  :options="utilities_options"
                  id="utilities" name="utilities"
                  placeholder="Select utilities"
                >
                </multiselect>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="losses">8.1 Losses Details</label>
                <multiselect
                  v-model="ses.losses"
                  :multiple="true"
                  :clear-on-select="false"
                  :preserve-search="true"
                  track-by="id"
                  :preselect-first="true"
                  :options="losses_options"
                  :custom-label="customLoss"
                  id="losses" name="losses"
                  placeholder="Select losses as per Field Book"
                >
                </multiselect>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="is_household_head">Are you Household Head? <span class="c-required">*</span></label>
                <select
                  v-model="ses.is_household_head"
                  v-validate="'required'"
                  id="is_household_head" name="household_head"
                  class="form-control form-control-sm"
                >
                  <option selected value="0">No</option>
                  <option value="1">Yes</option>
                </select>
                <div class="invalid-feedback">
                  Please enter yes/no
                </div>
              </div>
            </div>

            <div class="form-row mt-2">
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="loss_field_books">Losses as per Field Book</label>
                <multiselect
                  v-model="ses.loss_field_books"
                  id="loss_field_books"
                  :multiple="true"
                  :clear-on-select="false"
                  :preserve-search="true"
                  placeholder="Select losses"
                  track-by="id"
                  :preselect-first="true"
                  :options="loss_field_books"
                  :custom-label="customLossFieldBook"
                >
                </multiselect>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="is_disable">Is Disabled? <span class="c-required">*</span></label>
                <select
                  v-model="ses.is_disable"
                  v-validate="'required'"
                  id="is_disable" name="disable"
                  class="form-control form-control-sm"
                >
                  <option selected value="0">No</option>
                  <option value="1">Yes</option>
                </select>
                <div class="invalid-feedback">
                  Please enter yes/no
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="field_book_sl">Field Book Serial No.</label>
                <input
                  type="number"
                  v-model="ses.field_book_sl"
                  id="field_book_sl" name="field_book_sl"
                  placeholder="Present address"
                  class="form-control form-control-sm"
                />
                <div class="invalid-feedback">
                  Please enter Field Book No. Max 6 digits only
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="present_address">Present Address</label>
                <input type="text"
                  v-model="ses.present_address"
                  id="present_address" name="present_address"
                  placeholder="Present address"
                  class="form-control form-control-sm"
                />
                <div class="invalid-feedback">
                  Please enter present address
                </div>
              </div>
            </div>

            <div class="form-row mt-2">
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="worker_name">Survey Conducted By <span class="c-required">*</span></label>
                <select
                  v-model="ses.ses_worker_id"
                  v-validate="'required'"
                  id="worker_name" name="worker_name"
                  class="form-control form-control-sm"
                >
                  <option selected disabled :value="''"
                    >Select Worker who conduct Survey</option
                  >
                  <option
                    v-for="(worker, index) in workers"
                    :key="index"
                    :value="worker.id"
                    >{{ worker.name }}</option
                  >
                </select>
                <div class="invalid-feedback">
                  Please select Worker.
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="survey_date">Survey Conducted Date <span class="c-required">*</span></label>
                <datepicker v-model="ses.survey_date" v-validate="'required'" id="survey_date" name="survey_date"
                  :format="customDateSurvey">
                </datepicker>
              </div>
            </div>

            <div class="form-row mt-4 mb-2">
              <div class="col">
                <button v-if="userPermission.includes('ses-edit')"
                  class="btn btn-warning waves-effect waves-light mr-2" @click.prevent="update(1)">
                  Save and Exit
                </button>
                <button
                  class="btn btn-success waves-effect waves-light mr-2" @click.prevent="update(2)"
                >
                  Save and Next
                </button>
              </div>
            </div>
          </form>
        </b-card>
      </div>
    </div>
  </Layout>
</template>

<script>
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import Multiselect from "vue-multiselect";

import appConfig from "@src/app.config";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import http from "@state/http";

export default {
  page: {
    title: "Fill up SES Form",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, Datepicker, Multiselect },
  data() {
    return {
      title: "Update SES",
      items: [
        {
          text: "Update :: Socio Economic Survey",
          href: "/ses"
        },
        {
          text: "Dashboard",
          active: true
        }
      ],
      ep_types: [],
      villages: [],
      mouzas: [],
      unions: [],
      upazillas: [],
      districts: [],
      divisions: [],
      genders: [],
      religions: [],
      occupations: [],
      marital_statuses: [],
      educations: [],
      family_relations: [],
      cprs: [],
      workers: [],
      losses_options: [],
      utilities_options: [],
      loss_field_books: [],
      ses: {
        c_ep_type_id: 1,
        form_no: "",
        mobile: "",
        id_type: "N",
        nid: "",
        household_number: "",
        name: "",
        father_husband_name: "",
        mother_name: "",
        dob: "",
        c_gender_id: "",
        c_religion_id: 1,
        c_education_id: "",
        c_marital_status_id: "",
        c_occupation_id: "",
        c_village_id: "",
        c_mouza_id: "",
        c_union_id: "",
        c_upazila_id: "",
        c_district_id: "",
        c_division_id: "",
        yearly_income: "",
        yearly_exp: "",
        indigenous: "N/A",
        inistitution_sec: "N/A",
        c_cpr_id: 999,
        is_household_head: 1,
        is_disable: 0,
        field_book_sl: "",
        ses_worker_id: "",
        present_address: "",
        utilities: [],
        losses: [],
        loss_field_books: []
      },
      validation_errors: {},
      show: false,
    };
  },

  methods: {
    customLoss(option) {
      return `${option.id} - ${option.desc}`;
    },
    customLossFieldBook(option) {
      return `${option.id} - ${option.desc}`;
    },
    customDateDob(date) {
      this.ses.dob = moment(date).format("YYYY-MM-DD");
      return moment(date).format("YYYY-MM-DD");
    },
    customDateSurvey(date) {
      this.ses.survey_date = moment(date).format("YYYY-MM-DD");
      return moment(date).format("YYYY-MM-DD");
    },

    update(exitType) {
      let ses_id = this.$route.params.ses_id;

      this.$validator.validate().then(valid => {
        if (valid) {
          http
            .put("api/seses/" + this.ses.id, this.ses)
            .then(response => {
              if (!response.data.error) {
                if (exitType === 1) {
                  if (response.data.permissionError) {
                    this.toast(response.data.permissionError, "Error", 5000, "danger");
                    this.$router.push("/ses/edit/" + this.$route.params.ses_id);
                  } else {
                    this.toast(response.data.message, "Success", 5000, "success");
                    this.$router.push("/ses/views/" + this.$route.params.ses_id);
                  }
                }
                if (exitType === 2) {
                  if (response.data.permissionError) {
                    this.toast(response.data.permissionError, "Error", 5000, "danger");
                    this.$router.push("/ses/edit/" + this.$route.params.ses_id);
                  } else {
                    this.toast(response.data.message, "Success", 5000, "success");
                    this.$router.push("/ses/create/step-two/" + this.$route.params.ses_id);
                  }

                }
              }
            })
            .catch(error => {
              this.validation_errors = error.response.data.errors;
              this.show = true;
              this.hide();
            });
        }
      });
    },

    getSes() {
      let ses_id = this.$route.params.ses_id;

      http.get("api/seses/" + ses_id + "/edit/").then(response => {
        if (!response.data.error) {
          this.ses = response.data.ses;
        }
      });
    },

    getCodes() {
      http.get("api/ses/codes").then(response => {
        //console.log(response);
        if (!response.error) {
          let data = response.data;
          this.ep_types = data.ep_types;
          this.genders = data.genders;
          this.unions = data.unions;
          this.villages = data.villages;
          this.districts = data.districts;
          this.upazillas = data.upazillas;
          this.religions = data.religions;
          this.occupations = data.occupations;
          this.mouzas = data.mouzas;
          this.marital_statuses = data.marital_statuses;
          this.educations = data.educations;
          this.divisions = data.divisions;
          this.pref_train_times = data.pref_train_times;
          this.family_relations = data.family_relations;
          this.cprs = data.cprs;
          this.losses_options = data.losses;
          this.loss_field_books = data.loss_field_books;
          this.utilities_options = data.utilities;
          this.workers = data.workers;
        }
      });
    },

    getAddress(village_id) {
      let village = this.villages.find(v => v.id == village_id);

      let mouza = this.mouzas.find(m => m.id == village.c_mouza_id);
      this.ses.c_mouza_id = mouza.id;

      let union = this.unions.find(u => u.id == mouza.c_union_id);
      this.ses.c_union_id = union.id;

      let upazila = this.upazillas.find(d => d.id == union.c_upazila_id);
      this.ses.c_upazila_id = upazila.id;

      let district = this.districts.find(d => d.id == upazila.c_district_id);
      this.ses.c_district_id = district.id;

      let division = this.divisions.find(dv => dv.id == district.c_division_id);
      this.ses.c_division_id = division.id;
    },
    hide() {
      setTimeout(() => {
        this.show = false;
      }, 5000);
    },
    toast($message, $title, $autoHideDelay, $variant) {
      this.$bvToast.toast($message, {
        title: $title,
        autoHideDelay: $autoHideDelay,
        variant: $variant
      });
    }
  },
  mounted() {
    this.getCodes();
    this.getSes();
  },
  computed: {
    userPermission () {
      return this.$store.state.user
    }
  },
  created () {
    this.$store.dispatch('getUserPermission')
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.custom-select {
  -webkit-appearance: unset;
}
.vdp-datepicker input {
  width: 100%;
  border-radius: 3px;
  border: 1px solid #ced4da;
  height: 30px;
  padding-left: 15px;
  color: #6b757d;
}
.multiselect__tags {
  border-color: #ced4da;
  border-radius: 3px;
  min-height: 30px;
  padding: 4px 25px 0px 10px;
  margin-bottom: 0;
}
.multiselect__tag {
  margin-bottom: 0px;
}
.multiselect__placeholder {
  margin-bottom: 0px;
}
.multiselect__select {
  height: 30px;
}
.custom-select {
  color: #6c757d !important;
}
  .c-required{
    color: red;
  }
</style>
